import React from 'react';

function ApproveLeaveTab({ leaves, users, onApprove }) {
  const getUserName = (userId) => {
    const user = users.find(u => u.id === userId);
    return user ? user.name : 'Unknown';
  };

  const getUserEmail = (userId) => {
    const user = users.find(u => u.id === userId);
    return user ? user.email : 'Unknown';
  };

  const handleApprove = (leaveId) => {
    if (!window.confirm("Are you sure you want to approve this leave?")) return;

    // 1️⃣ Find the selected leave
    const selectedLeave = leaves.find((l) => l.id === leaveId);

    if (!selectedLeave) {
      alert("Leave not found");
      return;
    }

    const userId = selectedLeave.user_id;
    const selectedCreatedAt = new Date(selectedLeave.created_at);

    // 2️⃣ Get all pending leaves of same user
    const userPendingLeaves = leaves.filter(
      (l) => l.user_id === userId && l.status === "pending",
    );

    // 3️⃣ Check if any pending leave is older than current leave
    const hasOlderPending = userPendingLeaves.some((l) => {
      return new Date(l.created_at) < selectedCreatedAt;
    });

    if (hasOlderPending) {
      alert("First approve/reject the earlier leave");
      return;
    }

    // 4️⃣ Safe to approve
    // console.log("Approving leave:", leaveId);
    onApprove(leaveId, "approved");
  };


  const handleReject = (leaveId) => {
    if (window.confirm('Are you sure you want to reject this leave?')) {
      onApprove(leaveId, 'rejected');
    }
  };

  return (
    <div data-testid="approve-leave-tab">
      <h2
        style={{
          fontSize: "1.5rem",
          fontWeight: "700",
          marginBottom: "1.5rem",
        }}
      >
        Pending Leave Requests
      </h2>

      {leaves.length > 0 ? (
        <div style={{ overflowX: "auto" }}>
          <table className="data-table" data-testid="pending-leaves-table">
            <thead>
              <tr>
                <th>Employee</th>
                <th>Email</th>
                <th>Type</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Duration</th>
                <th>Reason</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {leaves.map((leave) => (
                <tr
                  key={leave.id}
                  data-testid={`pending-leave-row-${leave.id}`}
                >
                  <td data-testid={`leave-user-name-${leave.id}`}>
                    {getUserName(leave.user_id)}
                  </td>
                  <td data-testid={`leave-user-email-${leave.id}`}>
                    {getUserEmail(leave.user_id)}
                  </td>
                  <td style={{ textTransform: "capitalize" }}>
                    {leave.leave_type}
                  </td>
                  <td>
                    {new Date(leave.start_date).toLocaleDateString("en-IN")}
                  </td>
                  <td>
                    {new Date(leave.end_date).toLocaleDateString("en-IN")}
                  </td>
                  <td>
                    {leave.duration} {leave.duration === 1 ? "day" : "days"}
                  </td>
                  <td>{leave.reason}</td>
                  <td>
                    <div className="action-buttons">
                      <button
                        className="action-btn approve-btn"
                        onClick={() => handleApprove(leave.id)}
                        data-testid={`approve-leave-btn-${leave.id}`}
                      >
                        Approve
                      </button>
                      <button
                        className="action-btn reject-btn"
                        onClick={() => handleReject(leave.id)}
                        data-testid={`reject-leave-btn-${leave.id}`}
                      >
                        Reject
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="empty-state" data-testid="no-pending-leaves-message">
          <p>No pending leave requests</p>
          <small style={{ color: "#a0aec0" }}>
            All leave requests have been processed
          </small>
        </div>
      )}
    </div>
  );
}

export default ApproveLeaveTab;